import electrondeviceletters from "./assets/2015.png";
import transactionsonelectrondevices from "./assets/2016.png";
import compoundsemiconductorweek from "./assets/csw.png";
import thesis from "./assets/thesis.png";
export const publicationArr = [
  {
    name: "Suppression of Current Collapse in Enhancement Mode GaN-Based HEMTs Using an AlGaN/GaN/AlGaN Double Heterostructure",
    year: "07 March 2017",
    publisher: "IEEE TED",
    coWriter: "Shin-Yi Ho; Chun-Hsun Lee; An-Jye Tzou; Hao-Chung Kuo; Yuh-Renn Wu; JianJang Huang",
    link: "https://ieeexplore.ieee.org/abstract/document/7873300",
    pic: transactionsonelectrondevices,
  },
  {
    name: "Current collapse suppression by SiO2 passivation in p-GaN/AlGaN/GaN enhancement-mode high electron mobility transistors",
    year: "26-30 June 2016",
    publisher: "IEEE CSW",
    coWriter: "Shin-Yi Ho; Chih-Hao Wang; JianJang Huang",
    link: "https://ieeexplore.ieee.org/abstract/document/7528613",
    pic: compoundsemiconductorweek,
  },
  {
    name: "Suppression of Current Collapse in Enhancement-Mode AlGaN/GaN High Electron Mobility Transistors",
    year: "06 November 2015",
    publisher: "IEEE EDL",
    coWriter: "Chih-Hao Wang; Shin-Yi Ho; Jian Jang Huang",
    link: "https://ieeexplore.ieee.org/abstract/document/7321782",
    pic: electrondeviceletters,
  },
  {
    name: "Fabrication and Current Collapse Characterizations of Enhancement-Mode AlGaN/GaN High Electron Mobility Transistors",
    year: "June 2016",
    publisher: "Airitilibrary",
    coWriter: "Shin-Yi Ho",
    link: "https://www.airitilibrary.com/Publication/alDetailedMesh1?DocID=U0001-2907201611231600",
    pic: thesis,
  },
];
